// extracted by mini-css-extract-plugin
export default {"dayContainer":"styles_dayContainer__L-Lxm","dateHeader":"styles_dateHeader__QBJBN","frame":"styles_frame__zquPZ"};